import {
  DeliveryCompanyDeliveriesGroup,
  DriverInDeliveriesListItem
} from "../financial.types";

import { getDriversDeliveriesTotals } from "./getDriversDeliveriesTotals";

/** Drivers who do not belong to any delivery company are gathered here. */
export const INDEPENDENT_DRIVERS_GROUP_ID = "independent";

/**
 * Turns the flat list of drivers the API returns into
 * `company -> drivers` groups with the company level totals.
 * Independent drivers end up in a single trailing group.
 */
export const groupDriversByDeliveryCompany = (
  drivers: DriverInDeliveriesListItem[]
): DeliveryCompanyDeliveriesGroup[] => {
  const groups = new Map<string, DriverInDeliveriesListItem[]>();

  drivers.forEach((driver) => {
    const groupId = driver.deliveryCompany?.id ?? INDEPENDENT_DRIVERS_GROUP_ID;
    const group = groups.get(groupId);

    if (group) {
      group.push(driver);
    } else {
      groups.set(groupId, [driver]);
    }
  });

  return [...groups.entries()]
    .map(([id, groupDrivers]) => ({
      id,
      company: groupDrivers[0].deliveryCompany,
      drivers: groupDrivers,
      totals: getDriversDeliveriesTotals(groupDrivers)
    }))
    .sort((a, b) => {
      if (!a.company) return 1;
      if (!b.company) return -1;

      return a.company.name.localeCompare(b.company.name);
    });
};
